// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface NewsletterIconSignature {
  Element: SVGSVGElement;
}

export const NewsletterIcon: TOC<NewsletterIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18 9H20V2H4V9H6V4H18V9ZM20 22H4C2.897 22 2 21.103 2 20V11C2 10.612 2.225 10.259 2.576 10.095C2.926 9.93 3.343 9.984 3.64 10.232L9.362 15H14.638L20.36 10.231C20.658 9.983 21.072 9.93 21.424 10.094C21.775 10.258 21.999 10.612 21.999 10.999V19.999C22 21.103 21.104 22 20 22ZM4 13.135V20H20.002L20.001 13.135L15.641 16.769C15.461 16.918 15.234 17 15 17H9C8.767 17 8.54 16.918 8.36 16.769L4 13.135ZM8 6H16V8H8V6ZM14 9H8V11H14V9Z"/>
</svg>
</template>;